"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateFromPesel = void 0;
function dateFromPesel(pesel) {
    if (!pesel) {
        return;
    }
    const peselArray = [];
    for (let i = 0; i < 11; i++) {
        peselArray[i] = parseInt(pesel.substring(i, i + 1));
        if (isNaN(peselArray[i])) {
            return;
        }
    }
    const weight = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3, 1];
    let sum = 0;
    for (let i = 0; i < 11; i++) {
        sum += weight[i] * peselArray[i];
    }
    if (sum % 10 != 0) {
        return;
    }
    let year = 1900 + peselArray[0] * 10 + peselArray[1];
    if (peselArray[2] >= 2 && peselArray[2] < 8) {
        year += Math.floor(peselArray[2] / 2) * 100;
    }
    if (peselArray[2] >= 8) {
        year -= 100;
    }
    const month = (peselArray[2] % 2) * 10 + peselArray[3];
    const day = peselArray[4] * 10 + peselArray[5];
    return `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
}
exports.dateFromPesel = dateFromPesel;
//# sourceMappingURL=dateFromPesel.js.map